import { createBasicWavetableCatalog } from "./basicTables";
import { WAVETABLE_FILE_CATALOG } from "./fileCatalog.generated";
import type { WavetableCatalogEntry } from "./types";

let cached: WavetableCatalogEntry[] | null = null;

/** Full factory catalog: procedural basics + KRC + BVKER file tables. */
export function getWavetableCatalog(): readonly WavetableCatalogEntry[] {
  if (!cached) {
    cached = [...createBasicWavetableCatalog(), ...WAVETABLE_FILE_CATALOG];
  }
  return cached;
}

export function findWavetableCatalogEntry(id: string): WavetableCatalogEntry | undefined {
  return getWavetableCatalog().find(entry => entry.id === id);
}

export function defaultWavetableTableId(): string {
  return "basic/saw-square";
}
